/// <reference path="../../../vendor/typings/angularjs/angular.d.ts" />

module Eseebase {
    export class FloorplanController implements angular.IController {
        public floorPlans: FloorPlanPagedResult;
        public filters: ModelFilterViewModel;
        public erroLoadingData: boolean;
        public showCorrections: string;
        public features: CompanyFeatureList;
        public fileToken: string;
        public isLoading: boolean;
        private associations: OrganizationalUnitViewModel[];
        $onInit = () => { };

        constructor(private $scope: any,
            private buildingService: BuildingService,
            private floorPlanService: FloorPlanService,
            private $q: ng.IQService,
            private $timeout: ng.ITimeoutService,
            private $mdDialog: any,
            private $window: ng.IWindowService,
            private organizationSettingsService: OrganizationSettingsService,
            private fileService: FileService,
            private $rootScope: ng.IRootScopeService,
            private textService: TextService,
            private $routeParams: any,
            private universalStorageService: UniversalStorageService,
            private organizationService: OrganizationService
        ) {
            var vm = this;
            this.floorPlans = new FloorPlanPagedResult();
            organizationSettingsService.getFeatures().then((features: CompanyFeatureList) => vm.features = features, () => vm.features = null);
            this.fileService.getFileToken().then((t) => vm.fileToken = t);
            var isMyReports = false;
            if (vm.$window.location.hash == '#!/reports') {
                isMyReports = true;
                this.$scope.$on('filter-change', () => {
                    vm.floorPlans = new FloorPlanPagedResult();
                    vm.loadData(true);
                });
                this.$scope.$on('filter-delete', () => {
                    vm.floorPlans = new FloorPlanPagedResult();
                    vm.loadData(true);
                });
                vm.showCorrections = 'all';
                vm.floorPlans = new FloorPlanPagedResult();
                vm.loadData(true);
            }
            else {
                this.$scope.$on('loadFloorplans', function (e, pageNumber) {
                    vm.floorPlans = new FloorPlanPagedResult();
                    vm.loadData(false);
                    if (vm.$routeParams.correctionId != null) {
                        vm.$timeout(() => {
                            vm.openCorrectionById(null, vm.$routeParams.correctionId, null);
                        }, 1000);
                    }
                });
            }
            this.$scope.$on('floorplanLoadMore', () => {
                if (!vm.floorPlans.isLastPage) {
                    vm.loadData(isMyReports);
                }
            });
            this.$scope.imageError = function (sender) {
                if (sender.src != null && sender.src != '' &&
                    sender.src.toLowerCase().match(/(?=[\w\s\-\(\)\[\]\%\+]+(\.)\w{3,4}$).+|(?=[\w\s\-\(\)\[\]\%\+]+(\.)\w{3,4}[\?])[^\?]*/g)[0].indexOf(".png") > -1 &&
                    sender.src.indexOf('image/resize') == -1) {
                    sender.src = vm.universalStorageService.getThumbnailUrl(sender.src.replace(/\-w100\./g, '.'));
                }
                else {
                    sender.src = "/assets/img/no-image-icon-32.png?x=1";
                }
            }
            this.loadOrganizations();
        }

        public getPreviewUrl(url: string) {
            if (url.indexOf('.blob.core') == -1) {
                return url + this.fileToken;
            }
            if (url.indexOf('/preview-') > -1) {
                return url;
            }
            return url.replace(/\.png/g, '-w100.png');
        }

        public loadData(isMyReports: boolean) {
            if (this.floorPlans.isLastPage || this.isLoading) {
                return;
            }
            var vm = this;
            this.erroLoadingData = false;
            this.filters = this.buildingService.getFilters();
            this.isLoading = true;
            var lastId = '';
            if (vm.floorPlans.lastId != null) {
                lastId = vm.floorPlans.lastId;
            }
            this.floorPlanService.getFloorPlans(this.filters, this.showCorrections == 'all', this.showCorrections == 'reported', this.showCorrections == 'modified', isMyReports, lastId).then((data: FloorPlanPagedResult) => {
                vm.isLoading = false;
                vm.floorPlans.results = vm.floorPlans.results.concat(data.results);
                if (data == null || data.results == null || data.results.length == 0) {
                    vm.floorPlans.isLastPage = true;
                }
                if (data.totalNumberOfRecords > 0 || vm.floorPlans.results.length == 0) {
                    vm.$scope.vm.totalResultCount = data.totalNumberOfRecords;
                }
                vm.floorPlans.lastId = data.lastId;
                
            }, () => {
                vm.isLoading = false;
                vm.erroLoadingData = true;
            });
        }

        private loadOrganizations() {
            var vm = this;
            vm.organizationService.list().then((response: OrganizationalUnitViewModel[]) => {
                vm.associations = response;
            });
        }

        public hideStandardLocality(): boolean {
            if (this.organizationSettingsService.uiStyling != null)
            {
                return this.organizationSettingsService.uiStyling.modelListHideStandardLocality();
            }
            return false;
        }

        public showDetailedLocality(): boolean {
            if (this.organizationSettingsService.uiStyling != null)
            {
                return this.organizationSettingsService.uiStyling.modelListShowDetailedLocality();
            }
            return false;
        }

        public getAssociationName(associationNumber: string) {
            var vm = this;
            if (associationNumber != null && associationNumber != '' && associationNumber != 'null') {
                var associationName;
                var association = this.associations.filter(c => c.number == associationNumber);
                if (association != null && association.length > 0) {
                    associationName = association[0].name;
                }
                if (associationName != null && associationName != '') {
                    return associationName;
                } else {
                    return associationNumber;
                }
            }
            return ' ';
        }

        public getDepartmentName(associationNumber: string, departmentNumber: string) {
            var vm = this;
            if (associationNumber != null && associationNumber != '' && associationNumber != 'null') {
                if (departmentNumber != null && departmentNumber != '' && departmentNumber != 'null') {
                    var departmentName;
                    var association = this.associations.filter(c => c.number == associationNumber);
                    if (association != null && association.length > 0) {
                        var department = association[0].children.filter(c => c.number == departmentNumber);
                        if (department != null && department.length > 0) {
                            departmentName = department[0].name;
                        }
                    }
                    if (departmentName != null && departmentName != '') {
                        return departmentName;
                    } else {
                        return departmentNumber;
                    }
                }
            }
            return ' ';
        }

        public showCorrectionSelected() {
            this.floorPlans = new FloorPlanPagedResult();
            this.loadData(true);
        }
        
        public showFloorplanDialog(floorplanUrl: FloorplanUrlViewModel, $event) {
            var vm = this;
            var dialog = {
                controller: function () {
                    this.url = floorplanUrl.alternativeUrl != null && floorplanUrl.alternativeUrl != '' ? floorplanUrl.alternativeUrl : floorplanUrl.url ;
                    this.fileName = floorplanUrl.fileName;
                    this.$mdDialog = vm.$mdDialog;
                    this.maxWidth = 200;
                    this.maxHeight = 400;
                    this.fileToken = vm.fileToken;
                    this.resizeWindow = function () {
                        this.maxWidth = window.innerWidth
                            || document.documentElement.clientWidth
                            || document.body.clientWidth;

                        this.maxWidth = this.maxWidth;

                        this.maxHeight = window.innerHeight
                            || document.documentElement.clientHeight
                            || document.body.clientHeight;

                        this.maxHeight = this.maxHeight;
                    };
                    this.resizeWindow();
                    var self = this;
                    $(window).resize(() => self.resizeWindow());
                },
                controllerAs: 'vm',
                templateUrl: '/app/dialog/floorplan.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                targetEvent: $event
            };
            this.$mdDialog.show(dialog);
        }

        public openCorrection(fp: FloorplanViewModel, $event) {
            var dialog = {
                locals: { floorplan: fp, correctionId: null, correction: null},
                controller: 'CorrectionController',
                controllerAs: 'vm',
                templateUrl: '/app/dialog/floorplan-correction.html',
                parent: angular.element(document.body),
                clickOutsideToClose: false,
                targetEvent: $event,
                escapeToClose: false,
                multiple: true
            };
            this.$mdDialog.show(dialog);
        }

        public deleteCorrection(fp: FloorplanViewModel, $event) {
            var confirm = this.$mdDialog.confirm()
                .title('Delete?')
                .textContent('Are you sure, you want to delete the correction for "' + fp.housingNumber + '"?')
                .ariaLabel('Delete')
                .ok("OK")
                .cancel("Cancel");
            var vm = this;
            this.$mdDialog.show(confirm).then(() => {
                this.floorPlanService.getCorrection(fp.associationNumber, fp.departmentNumber, fp.housingNumber).then((data: CorrectionViewModel) => {
                    if (data != null && data.id != '') {
                        vm.floorPlanService.deleteCorrection(data.id).then(() => {
                            vm.$timeout(() => fp.hasCorrection = false);
                        }, (rejection) => {
                            switch (rejection.status) {
                                case 401:
                                    vm.showAlert('Unauthorized', 'You do not have permissions for this action.');
                                    break;
                                default:
                                    vm.showAlert('Error', 'Internal error has occured while saving data.');
                                    break;
                            }
                        })
                    }
                }, (rejection) => {
                    switch (rejection.status) {
                        case 401:
                            vm.showAlert('Unauthorized', 'You do not have permissions for this action.');
                            break;
                        default:
                            vm.showAlert('Error', 'Internal error has occured while saving data.');
                            break;
                    }
                })
            });
        }

        public openCorrectionById(fp: FloorplanViewModel, id: string, $event) {
            var dialog = {
                locals: {
                    floorplan: fp,
                    correctionId: id,
                    correction: null
                },
                controller: 'CorrectionController',
                controllerAs: 'vm',
                templateUrl: '/app/dialog/floorplan-correction.html',
                parent: angular.element(document.body),
                clickOutsideToClose: false,
                targetEvent: $event,
                escapeToClose: false
            };
            this.$mdDialog.show(dialog);
        }

        public showHistory(fp: FloorplanViewModel, $event) {
            if ($event != null && $event.target != null) {
                var sender = angular.element($event.target);
                var details = sender.closest('tr').prev().find('.details');
                var vm = this;
                if (fp.isExpanded != true) {
                    fp.isExpanded = true;
                    if (fp.changelog == null) {
                        vm.$timeout(() => details.css('height', '100px'));
                        this.floorPlanService.getApartmentChangelog(fp.associationNumber, fp.departmentNumber, fp.localizer, fp.housingNumber).then((log: FloorplanChangelog) => {
                            fp.changelog = log;
                            vm.$timeout(() => details.css('height', details.find('.detail-container').height() + 'px'));
                        });
                    }
                    else {
                        details.css('height', details.find('.detail-container').height() + 'px');
                    }
                }
                else {
                    fp.isExpanded = false;
                    details.css('height', '0px');
                }

                if (sender.hasClass('active')) {
                    sender.removeClass('active');
                }
                else {
                    sender.addClass('active');
                }
            }
        }

        private showAlert(title: string, message: string) {
            this.$mdDialog.show(
                this.$mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title(title)
                    .textContent(message)
                    .ok('OK')
            );
        }

        public includeFeedbackModule(associationNumber: string) {
            return this.features != null && this.features.includeFeedbackModule([associationNumber]);
        }
    }

    FloorplanController.$inject = ['$scope', 'BuildingService', 'FloorPlanService', '$q', '$timeout', '$mdDialog', '$window', 'OrganizationSettingsService', 'FileService', '$rootScope', 'TextService', '$routeParams', 'UniversalStorageService', 'OrganizationService'];

    angular
        .module('eseebase')
        .controller('FloorplanController', FloorplanController);
}
